import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'Chiara',
  city: 'Milano'
}, {
  name: 'Elena',
  city: 'Roma'
}, {
  name: 'Matteo',
  city: 'Napoli'
}, {
  name: 'Silvia',
  city: 'Torino'
}, {
  name: 'Luca',
  city: 'Bologna'
}, {
  name: 'Valentina',
  city: 'Firenze'
}, {
  name: 'Andrea',
  city: 'Palermo'
}, {
  name: 'Martina',
  city: 'Genova'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-187">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} className="fixed bottom-4 left-4 sm:bottom-8 sm:left-8 z-50 max-w-[300px] w-full" data-id="element-188">
          <div className="bg-white border border-brand-sage/40 rounded-xl p-4 shadow-lg relative overflow-hidden group" data-id="element-189">
            <div className="absolute top-0 left-0 w-full h-1 bg-brand-olive" data-id="element-190" />

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-brand-text-muted/50 hover:text-brand-text-main" data-id="element-191">
              <XIcon className="w-4 h-4" data-id="element-192" />
            </button>

            <div className="flex items-center gap-3" data-id="element-193">
              <div className="w-10 h-10 rounded-full bg-brand-sage-light border border-brand-sage/30 flex items-center justify-center text-brand-olive font-bold text-lg shrink-0" data-id="element-194">
                {currentBuyer.name.charAt(0)}
              </div>
              <div data-id="element-195">
                <p className="text-sm text-brand-text-main font-medium leading-tight" data-id="element-196">
                  <span className="font-bold" data-id="element-197">{currentBuyer.name}</span> da{' '}
                  {currentBuyer.city} ha appena acquistato il Kit
                </p>
                <div className="flex items-center gap-2 mt-1" data-id="element-198">
                  <span className="flex items-center gap-1 text-xs text-brand-olive font-bold" data-id="element-199">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-olive animate-pulse" data-id="element-200" />
                    Verificato
                  </span>
                  <span className="text-xs text-brand-text-muted" data-id="element-201">
                    {timeAgo} minuti fa
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}